<template>
  <CModal
    centered
    :closeOnBackdrop="false"
    :show.sync="modalVisible"
    addContentClasses="border-0 modal-border-radius"
  >
    <div slot="header" />
    <div slot="header-wrapper" />
    <div slot="body-wrapper">
      <closeButton :setModalVisible="setModalVisible" />
      <CContainer style="padding: 3.125rem">
        <CRow alignHorizontal="center">
          <font-awesome-icon
            icon="exclamation-circle"
            style="color: lightgrey"
            class="IconWarning"
          />
        </CRow>
        <CRow alignHorizontal="center" style="margin-bottom: 45px">
          <h5 v-if="!status">Are you sure you want to turn on the test?</h5>
          <h5 v-if="status">Are you sure you want to turn off the test?</h5>
        </CRow>
        <CRow alignHorizontal="center">
          <CCol col="6">
            <div @click="setModalVisible()" class="button button-grey">
              CANCEL
            </div>
          </CCol>
          <CCol col="6">
            <div
              @click="onClick()"
              class="button button-green"
              style="margin: 0 0.7rem"
              v-if="!status"
            >
              Turn On
            </div>
            <div
              @click="onClick()"
              class="button button-pink"
              style="margin: 0 0.7rem"
              v-if="status"
            >
              Turn Off
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
    <div slot="footer" />
    <div slot="footer-wrapper" />
  </CModal>
</template>

<script>
import closeButton from "./closeButton";
export default {
  name: "ModalChangeStatus",
  props: {
    modalVisible: Boolean,
    setModalVisible: Function,
    dataObject: Object,
    status: Boolean,
  },
  components: {
    closeButton,
  },
  watch: {
    dataObject(val) {},
  },
  methods: {
    onClick() {
      this.$emit("returnChangeQuizStatus", this.dataObject);
    },
  },
};
</script>

<style>
.IconWarning {
  font-size: 100px;
  margin: 20px;
}
</style>